import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  NavbarAdmin,
  Modal,
  Resizer,
} from "../../components/CustomComponent.js";
import THUMBNAIL from "../../assets/images/thumbnail.png";
export default class Tiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "หน้าแรก",

      tab_ln: "th",

      slideIndex: 0,

      photo_index: [],
      photo_section3_index: "",
      photo_section4_index: [],
      photo_section5_index: "",
      howto_section6_index: [],
      customer_section7_index: [],
      
      photo_about: "",
      photo_about_3: [],
      photo_about_4: "",
      photo_about_5: "",
      photo_standards: "",
      map_contact: "",

      th_title_section2_index: "",
th_message_section2_index: "",
th_title1_section2_index: "",
th_message1_section2_index: "",
th_title2_section2_index: "",
th_message2_section2_index: "",
th_title3_section2_index: "",
th_message3_section2_index: "",
th_title_section3_index: "",
th_message_section3_index: "",
th_title_section5_index: "",
th_message_section5_index: "",
th_title_about: "",
th_message_about: "",
th_title_about_2: "",
th_message_about_2: "",
th_title_about_4: "",
th_message_about_4: "",
th_title_about_5: "",
th_message_about_5: "",
th_title_standards: "",
th_message_standards: "",
th_title_standards_2: "",
th_message_standards_2: "",
th_title_standards_3: "",
th_message_standards_3: "",
th_name_contact_1: "",
th_address_contact_1: "",
th_phone_contact_1: "",
th_fax_contact_1: "",
th_email_contact_1: "",
th_website_contact_1: "",

us_title_section2_index: "",
us_message_section2_index: "",
us_title1_section2_index: "",
us_message1_section2_index: "",
us_title2_section2_index: "",
us_message2_section2_index: "",
us_title3_section2_index: "",
us_message3_section2_index: "",
us_title_section3_index: "",
us_message_section3_index: "",
us_title_section5_index: "",
us_message_section5_index: "",
us_title_about: "",
us_message_about: "",
us_title_about_2: "",
us_message_about_2: "",
us_title_about_4: "",
us_message_about_4: "",
us_title_about_5: "",
us_message_about_5: "",
us_title_standards: "",
us_message_standards: "",
us_title_standards_2: "",
us_message_standards_2: "",
us_title_standards_3: "",
us_message_standards_3: "",
us_name_contact_1: "",
us_address_contact_1: "",
us_phone_contact_1: "",
us_fax_contact_1: "",
us_email_contact_1: "",
us_website_contact_1: "",

jp_title_section2_index: "",
jp_message_section2_index: "",
jp_title1_section2_index: "",
jp_message1_section2_index: "",
jp_title2_section2_index: "",
jp_message2_section2_index: "",
jp_title3_section2_index: "",
jp_message3_section2_index: "",
jp_title_section3_index: "",
jp_message_section3_index: "",
jp_title_section5_index: "",
jp_message_section5_index: "",
jp_title_about: "",
jp_message_about: "",
jp_title_about_2: "",
jp_message_about_2: "",
jp_title_about_4: "",
jp_message_about_4: "",
jp_title_about_5: "",
jp_message_about_5: "",
jp_title_standards: "",
jp_message_standards: "",
jp_title_standards_2: "",
jp_message_standards_2: "",
jp_title_standards_3: "",
jp_message_standards_3: "",
jp_name_contact_1: "",
jp_address_contact_1: "",
jp_phone_contact_1: "",
jp_fax_contact_1: "",
jp_email_contact_1: "",
jp_website_contact_1: "",

cn_title_section2_index: "",
cn_message_section2_index: "",
cn_title1_section2_index: "",
cn_message1_section2_index: "",
cn_title2_section2_index: "",
cn_message2_section2_index: "",
cn_title3_section2_index: "",
cn_message3_section2_index: "",
cn_title_section3_index: "",
cn_message_section3_index: "",
cn_title_section5_index: "",
cn_message_section5_index: "",
cn_title_about: "",
cn_message_about: "",
cn_title_about_2: "",
cn_message_about_2: "",
cn_title_about_4: "",
cn_message_about_4: "",
cn_title_about_5: "",
cn_message_about_5: "",
cn_title_standards: "",
cn_message_standards: "",
cn_title_standards_2: "",
cn_message_standards_2: "",
cn_title_standards_3: "",
cn_message_standards_3: "",
cn_name_contact_1: "",
cn_address_contact_1: "",
cn_phone_contact_1: "",
cn_fax_contact_1: "",
cn_email_contact_1: "",
cn_website_contact_1: "",
    };
  }

  async componentDidMount() {
    if (profile.ut !== "super_user") {
      window.location.href = "/admin/contact";
    }
    loading(false);
    if (!profile || profile?.ep < new Date().getTime()) {
      localStorage.removeItem("scp-profile");
      alert(
        "/login",
        "warning",
        "แจ้งเตือน",
        "Token หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
      );
    } else {
      await this.Get();
    }
    this.timer = setInterval(this.nextSlide, 5000);

    loading(false);
    this.Get();
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  nextSlide = () => {
    const { photo_index } = this.state;
    this.setState((prev) => ({
      slideIndex:
        prev.slideIndex === photo_index?.length - 1 ? 0 : prev.slideIndex + 1,
    }));
  };
  prevSlide = () => {
    const { photo_index } = this.state;
    this.setState((prev) => ({
      slideIndex:
        prev.slideIndex === 0 ? photo_index.length - 1 : prev.slideIndex - 1,
    }));
  };
  goToSlide = (index) => {
    this.setState({ slideIndex: index });
  };
  Get = async () => {
    loading(true);
    let response = await fetch(
      process.env.REACT_APP_API_URL + `/setting.json`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    let data = result || null;
    this.setState({ ...data });

    loading(false);
  };
  CreateUpdate = async () => {
    const {
      photo_index,
      photo_section3_index,
      photo_section4_index,
      photo_section5_index,
      howto_section6_index,
      customer_section7_index,
      
      photo_about,
      photo_about_3,
      photo_about_4,
      photo_about_5,
      photo_standards,
      map_contact,


      th_title_section2_index,
th_message_section2_index,
th_title1_section2_index,
th_message1_section2_index,
th_title2_section2_index,
th_message2_section2_index,
th_title3_section2_index,
th_message3_section2_index,
th_title_section3_index,
th_message_section3_index,
th_title_section5_index,
th_message_section5_index,
th_title_about,
th_message_about,
th_title_about_2,
th_message_about_2,
th_title_about_4,
th_message_about_4,
th_title_about_5,
th_message_about_5,
th_title_standards,
th_message_standards,
th_title_standards_2,
th_message_standards_2,
th_title_standards_3,
th_message_standards_3,
th_name_contact_1,
th_address_contact_1,
th_phone_contact_1,
th_fax_contact_1,
th_email_contact_1,
th_website_contact_1,

us_title_section2_index,
us_message_section2_index,
us_title1_section2_index,
us_message1_section2_index,
us_title2_section2_index,
us_message2_section2_index,
us_title3_section2_index,
us_message3_section2_index,
us_title_section3_index,
us_message_section3_index,
us_title_section5_index,
us_message_section5_index,
us_title_about,
us_message_about,
us_title_about_2,
us_message_about_2,
us_title_about_4,
us_message_about_4,
us_title_about_5,
us_message_about_5,
us_title_standards,
us_message_standards,
us_title_standards_2,
us_message_standards_2,
us_title_standards_3,
us_message_standards_3,
us_name_contact_1,
us_address_contact_1,
us_phone_contact_1,
us_fax_contact_1,
us_email_contact_1,
us_website_contact_1,

jp_title_section2_index,
jp_message_section2_index,
jp_title1_section2_index,
jp_message1_section2_index,
jp_title2_section2_index,
jp_message2_section2_index,
jp_title3_section2_index,
jp_message3_section2_index,
jp_title_section3_index,
jp_message_section3_index,
jp_title_section5_index,
jp_message_section5_index,
jp_title_about,
jp_message_about,
jp_title_about_2,
jp_message_about_2,
jp_title_about_4,
jp_message_about_4,
jp_title_about_5,
jp_message_about_5,
jp_title_standards,
jp_message_standards,
jp_title_standards_2,
jp_message_standards_2,
jp_title_standards_3,
jp_message_standards_3,
jp_name_contact_1,
jp_address_contact_1,
jp_phone_contact_1,
jp_fax_contact_1,
jp_email_contact_1,
jp_website_contact_1,

cn_title_section2_index,
cn_message_section2_index,
cn_title1_section2_index,
cn_message1_section2_index,
cn_title2_section2_index,
cn_message2_section2_index,
cn_title3_section2_index,
cn_message3_section2_index,
cn_title_section3_index,
cn_message_section3_index,
cn_title_section5_index,
cn_message_section5_index,
cn_title_about,
cn_message_about,
cn_title_about_2,
cn_message_about_2,
cn_title_about_4,
cn_message_about_4,
cn_title_about_5,
cn_message_about_5,
cn_title_standards,
cn_message_standards,
cn_title_standards_2,
cn_message_standards_2,
cn_title_standards_3,
cn_message_standards_3,
cn_name_contact_1,
cn_address_contact_1,
cn_phone_contact_1,
cn_fax_contact_1,
cn_email_contact_1,
cn_website_contact_1,
    } = this.state;
    loading(true);
    await fetch(process.env.REACT_APP_API_URL + `/setting.json`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        photo_index,
      photo_section3_index,
      photo_section4_index,
      photo_section5_index,
      howto_section6_index,
      customer_section7_index,
      
      photo_about,
      photo_about_3,
      photo_about_4,
      photo_about_5,
      photo_standards,
      map_contact,


      th_title_section2_index,
th_message_section2_index,
th_title1_section2_index,
th_message1_section2_index,
th_title2_section2_index,
th_message2_section2_index,
th_title3_section2_index,
th_message3_section2_index,
th_title_section3_index,
th_message_section3_index,
th_title_section5_index,
th_message_section5_index,
th_title_about,
th_message_about,
th_title_about_2,
th_message_about_2,
th_title_about_4,
th_message_about_4,
th_title_about_5,
th_message_about_5,
th_title_standards,
th_message_standards,
th_title_standards_2,
th_message_standards_2,
th_title_standards_3,
th_message_standards_3,
th_name_contact_1,
th_address_contact_1,
th_phone_contact_1,
th_fax_contact_1,
th_email_contact_1,
th_website_contact_1,

us_title_section2_index,
us_message_section2_index,
us_title1_section2_index,
us_message1_section2_index,
us_title2_section2_index,
us_message2_section2_index,
us_title3_section2_index,
us_message3_section2_index,
us_title_section3_index,
us_message_section3_index,
us_title_section5_index,
us_message_section5_index,
us_title_about,
us_message_about,
us_title_about_2,
us_message_about_2,
us_title_about_4,
us_message_about_4,
us_title_about_5,
us_message_about_5,
us_title_standards,
us_message_standards,
us_title_standards_2,
us_message_standards_2,
us_title_standards_3,
us_message_standards_3,
us_name_contact_1,
us_address_contact_1,
us_phone_contact_1,
us_fax_contact_1,
us_email_contact_1,
us_website_contact_1,

jp_title_section2_index,
jp_message_section2_index,
jp_title1_section2_index,
jp_message1_section2_index,
jp_title2_section2_index,
jp_message2_section2_index,
jp_title3_section2_index,
jp_message3_section2_index,
jp_title_section3_index,
jp_message_section3_index,
jp_title_section5_index,
jp_message_section5_index,
jp_title_about,
jp_message_about,
jp_title_about_2,
jp_message_about_2,
jp_title_about_4,
jp_message_about_4,
jp_title_about_5,
jp_message_about_5,
jp_title_standards,
jp_message_standards,
jp_title_standards_2,
jp_message_standards_2,
jp_title_standards_3,
jp_message_standards_3,
jp_name_contact_1,
jp_address_contact_1,
jp_phone_contact_1,
jp_fax_contact_1,
jp_email_contact_1,
jp_website_contact_1,

cn_title_section2_index,
cn_message_section2_index,
cn_title1_section2_index,
cn_message1_section2_index,
cn_title2_section2_index,
cn_message2_section2_index,
cn_title3_section2_index,
cn_message3_section2_index,
cn_title_section3_index,
cn_message_section3_index,
cn_title_section5_index,
cn_message_section5_index,
cn_title_about,
cn_message_about,
cn_title_about_2,
cn_message_about_2,
cn_title_about_4,
cn_message_about_4,
cn_title_about_5,
cn_message_about_5,
cn_title_standards,
cn_message_standards,
cn_title_standards_2,
cn_message_standards_2,
cn_title_standards_3,
cn_message_standards_3,
cn_name_contact_1,
cn_address_contact_1,
cn_phone_contact_1,
cn_fax_contact_1,
cn_email_contact_1,
cn_website_contact_1,
      }),
    });

    await fetch(process.env.REACT_APP_API_URL + `/updated.json`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ last_update: new Date().getTime() }),
    });
    alert("#", "success");
    loading(false);
  };
  render() {
    const {
      tab,
      tab_ln,
      slideIndex,

      photo_index,
      photo_section3_index,
      photo_section5_index,
      photo_section4_index,
      howto_section6_index,
      customer_section7_index,
      
      photo_about,
      photo_about_3,
      photo_about_4,
      photo_about_5,
      th_title_about,
      th_message_about,
      th_title_about_2,
      th_message_about_2,
      th_title_about_4,
      th_message_about_4,
      th_title_about_5,
      th_message_about_5,

      photo_standards,
      th_title_standards,
      th_message_standards,
      th_title_standards_2,
      th_message_standards_2,
      th_title_standards_3,
      th_message_standards_3,

      th_name_contact_1,
      th_address_contact_1,
      th_phone_contact_1,
      th_fax_contact_1,
      th_email_contact_1,
      th_website_contact_1,
      map_contact,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <NavbarAdmin />
        <div className="body p-3 mt-3 pb-5 position-relative">
          <h4 className="fw-bold mb-4">ตั้งค่าอื่นๆ</h4>
          <div className="d-flex justify-content-between mb-3">
            <div
              className="border-primary rounded-4 d-flex"
              style={{ padding: 2 }}
            >
              <button
                className={`btn btn-${
                  tab === "หน้าแรก" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab: "หน้าแรก" });
                }}
              >
                หน้าแรก
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab === "เกี่ยวกับเรา" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab: "เกี่ยวกับเรา" });
                }}
              >
                เกี่ยวกับเรา
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab === "มาตรฐานและงานวิจัย" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab: "มาตรฐานและงานวิจัย" });
                }}
              >
                มาตรฐานและงานวิจัย
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab === "ติดต่อเรา" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab: "ติดต่อเรา" });
                }}
              >
                ติดต่อเรา
              </button>
            </div>
            <div
              className="border-primary rounded-4 d-flex"
              style={{ padding: 2 }}
            >
              <button
                className={`btn btn-${
                  tab_ln === "th" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab_ln: "th" });
                }}
              >
                ไทย
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab_ln === "us" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab_ln: "us" });
                }}
              >
                อังกฤษ
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab_ln === "jp" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab_ln: "jp" });
                }}
              >
                ญี่ปุ่น
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${
                  tab_ln === "cn" ? "primary" : "link text-dark"
                } text-decoration-none px-3`}
                onClick={() => {
                  this.setState({ tab_ln: "cn" });
                }}
              >
                จีน
              </button>
            </div>
          </div>
          <div>
            {tab === "หน้าแรก" && (
              <div className="row">
                {/* Section 1 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 1</h3>
                  <div className="w-100 mb-2">
                    <div className="w-100">
                      <input
                        hidden
                        accept="image/*"
                        id="photo_index"
                        type="file"
                        onChange={async (e) => {
                          loading(true);
                          const file = e.target.files[0];
                          if (!file) return;

                          const reader = new FileReader();
                          reader.onloadend = async () => {
                            const base64 = reader.result;
                            console.log(base64); // ✅ base64
                            // setState(base64) หรือส่งไป API ได้เลย
                            const formdata = new FormData();
                            formdata.append("image", base64.split(",")[1]);

                            const response = await fetch(
                              "https://api.imgbb.com/1/upload?key=" +
                                process.env.REACT_APP_IMGBB_KEY,
                              {
                                method: "POST",
                                body: formdata,
                              }
                            );

                            const result = await response.json();

                            this.setState({
                              photo_index: [
                                ...photo_index,
                                {
                                  image: result.data.image.url,
                                  th: "",
                                  us: "",
                                  jp: "",
                                  cn: "",
                                },
                              ],
                            });
                            loading(false);
                          };
                          reader.readAsDataURL(file);

                          e.target.value = "";
                          e.target.files = null;
                        }}
                      />
                      {photo_index.length !== 0 && (
                        <div className="w-100">
                          {photo_index?.map((item, index) => (
                            <div className="card rounded-3 bg-secondary-light p-2 w-100 mb-2 shadow-sm position-relative">
                              <div className="d-flex">
                                <div className="hpx-100 wpx-100 rounded-3 border p-1 me-2 mb-3">
                                  <img
                                    alt="example"
                                    src={item.image}
                                    className="rounded-3"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                                <textarea
                                  className="form-control"
                                  placeholder="ข้อความปก.."
                                  rows={5}
                                  onChange={(e) => {
                                    photo_index[index][tab_ln] = e.target.value;
                                    this.setState({ photo_index });
                                  }}
                                  value={item[tab_ln]}
                                />
                              </div>

                              <span
                                className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -8, top: -8 }}
                                onClick={() => {
                                  photo_index.splice(index, 1);
                                  this.setState({ photo_index });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ))}
                          <button
                            className="btn btn-dark px-4"
                            onClick={() => {
                              document.getElementById("photo_index").click();
                            }}
                          >
                            เพิ่มรูปปก
                          </button>
                        </div>
                      )}
                      {photo_index.length === 0 && (
                        <div className="d-flex">
                          <div
                            className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                            onClick={() => {
                              document.getElementById("photo_index").click();
                            }}
                          >
                            {"\uf03e"}
                          </div>
                          <small className="text-secondary ps-3">
                            <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล
                            เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                            <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                            <br />
                            <b>ขนาดไฟล์สูงสุด:</b> 5MB
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div
                      className="w-100 text-white position-relative overflow-hidden"
                      style={{ height: 600, minHeight: 600 }}
                    >
                      {/* Slides */}
                      {photo_index?.map((item, index) => (
                        <div
                          key={index}
                          className="hero-slide position-absolute top-0 start-0 w-100 h-100"
                          style={{
                            backgroundImage: `url(${item.image || THUMBNAIL})`,
                            opacity: slideIndex === index ? 1 : 0,
                          }}
                        />
                      ))}

                      {/* Gradient + Content */}
                      <div
                        className="position-relative h-100 d-flex align-items-center"
                        style={{
                          background:
                            "linear-gradient(to right, rgba(0,0,0,0.8), rgba(0,0,0,0.2), rgba(0,0,0,0))",
                        }}
                      >
                        <div className="row container mx-auto">
                          <div className="col-12 col-md-8 col-xl-6">
                            <h5 className="fw-bold mb-2">
                              บริษัท เอเชีย อีโค เอิร์ท จำกัด
                            </h5>

                            {/* ✅ ข้อความตามสไลด์ */}
                            <h1 className="fw-bold mb-3">
                              {photo_index?.[slideIndex]?.th || ""}
                            </h1>

                            <button
                              className="btn btn-light px-4"
                              onClick={() =>
                                (window.location.href = "/contact")
                              }
                            >
                              ติดต่อเรา
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Controls */}
                      <button
                        className="carousel-btn left icon"
                        onClick={this.prevSlide}
                      >
                        {"\uf104"}
                      </button>
                      <button
                        className="carousel-btn right icon"
                        onClick={this.nextSlide}
                      >
                        {"\uf105"}
                      </button>

                      {/* Indicators */}
                      <div className="carousel-dots">
                        {photo_index?.map((_, i) => (
                          <span
                            key={i}
                            className={`dot ${
                              i === slideIndex ? "active" : ""
                            }`}
                            onClick={() => this.goToSlide(i)}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Section 2 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 2</h3>
                  <div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">หัวข้อหลัก</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อหลัก.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_section2_index"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_section2_index"]}
                      />
                    </div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">รายละเอียดหลัก</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียดหลัก.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_section2_index"]:
                              e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_section2_index"]}
                      />
                    </div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">หัวข้อรอง 1</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อรอง 1.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title1_section2_index"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title1_section2_index"]}
                      />
                    </div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">
                        รายละเอียดรอง 1<br />
                        <br />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="50"
                          height="50"
                          viewBox="0 0 100 100"
                          xmlSpace="preserve"
                          className="eco-icon"
                        >
                          <g>
                            <path
                              d="m30.67 54.253 4.296 2.597c.7 0 1.099-.3 1.099-.899-.1-.6-.2-1.099-.5-1.598l-9.39-17.582-20.778.5c-.7-.1-1.399.5-1.399 1.199v.3c0 .2.3.499.9.898l4.195 2.498-4.695 7.092C3.299 50.757 2.7 52.455 2.5 54.253c.1 1.399.5 2.797 1.299 3.996l14.185 24.674c-.3-1.499-.5-2.897-.5-4.396 0-2.697.9-5.194 2.398-7.392zM36.065 39.868l11.687-18.08c-4.395-9.89-8.99-14.885-13.885-14.885-2.997 0-4.895.799-5.994 2.497L16.885 26.982z"
                              fill="#1a4275"
                            />
                            <path
                              d="M26.575 88.817H49.05V65.44H27.374a91.756 91.756 0 0 0-4.995 7.692c-1.099 1.998-1.598 4.296-1.698 6.593 0 5.994 1.898 9.09 5.894 9.09zM72.926 35.573l10.09-16.783c.299-.599.499-1.198.499-1.798 0-.799-.3-1.099-.8-1.099-.3.2-.699.3-.998.4l-4.596 1.898L72.926 10c-1.798-3.697-5.494-5.595-11.088-5.595H35.665c2.298.6 4.495 1.499 6.493 2.897 2.697 2.098 5.395 6.094 8.192 11.888l5.194 10.789-3.796 1.798c-.4.2-.6.599-.6.999 0 .599.4.999 1.2 1.098zM82.915 85.32 97.5 58.848c-1.898 2.298-4.295 3.996-6.993 4.995-2.797.8-5.794 1.099-8.69.999H65.534v-3.397c0-1.298-.3-1.997-1-1.997-.399 0-.798.2-.998.499l-10.09 17.781 10.59 16.383c.798 1.199 1.498 1.698 2.097 1.399.6-.2.9-.5.9-.9v-5.594h8.99a6.935 6.935 0 0 0 6.892-3.696z"
                              fill="#1a4275"
                            />
                            <path
                              d="M76.622 61.445h9.69c2.697-.1 5.294-1.198 7.192-3.096 2.697-2.098 3.996-4.396 3.996-6.693 0-1.199-.4-2.298-1.099-3.197L84.913 30.778 65.034 42.366z"
                              fill="#1a4275"
                            />
                          </g>
                        </svg>
                      </div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียดรอง 1.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message1_section2_index"]:
                              e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message1_section2_index"]}
                      />
                    </div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">หัวข้อรอง 2</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อรอง 2.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title2_section2_index"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title2_section2_index"]}
                      />
                    </div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">
                        รายละเอียดรอง 2<br />
                        <br />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="50"
                          height="50"
                          viewBox="0 0 512 512"
                          xmlSpace="preserve"
                        >
                          <g>
                            <path
                              d="M256 0C148.013 0 60.16 87.854 60.16 195.84S148.014 391.68 256 391.68s195.84-87.854 195.84-195.84S363.987 0 256 0zm91.899 322.328L256 278.839l-91.899 43.489 12.962-100.839-69.758-73.961 99.909-18.833L256 39.493l48.785 89.2 99.91 18.833-69.758 73.962z"
                              fill="#1a4275"
                            />
                            <path
                              d="M285.277 155.544 256 102.014l-29.277 53.53-59.958 11.302 41.864 44.386-7.779 60.516L256 245.649l55.15 26.099-7.779-60.516 41.864-44.386zM119.195 443.452a102.17 102.17 0 0 0 37.469-13.244v-31.435a224.341 224.341 0 0 1-37.469-23.214zM355.336 430.208a102.17 102.17 0 0 0 37.469 13.244v-67.893a224.407 224.407 0 0 1-37.469 23.214zM186.664 410.876V512c22.209-3.206 42.63-13.521 58.624-29.838L256 471.234l10.712 10.928c15.994 16.316 36.415 26.632 58.624 29.838V410.876C303.222 417.98 279.897 421.68 256 421.68s-47.222-3.7-69.336-10.804z"
                              fill="#1a4275"
                            />
                          </g>
                        </svg>
                      </div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียดรอง 2.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message2_section2_index"]:
                              e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message2_section2_index"]}
                      />
                    </div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">หัวข้อรอง 3</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อรอง 3.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title3_section2_index"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title3_section2_index"]}
                      />
                    </div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">
                        รายละเอียดรอง 3<br />
                        <br />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="50"
                          height="50"
                          viewBox="0 0 512 512"
                          xmlSpace="preserve"
                        >
                          <g>
                            <path
                              d="m256 143.75 56.277 29.59-10.75-62.668 45.559-44.399-62.945-9.14L256 0l-28.14 57.133-62.946 9.14 45.559 44.399-10.75 62.668zM446.137 159.129l-28.14-57.024-28.142 57.024-62.914 9.14 45.528 44.387-10.75 62.68 56.277-29.59 56.309 29.59-10.782-62.68L512 168.27zM48.477 212.656l-10.782 62.68 56.309-29.59 56.277 29.59-10.75-62.68 45.528-44.386-62.914-9.141-28.141-57.024-28.14 57.024L0 168.269zM331 286c0-41.352-33.648-75-75-75s-75 33.648-75 75 33.648 75 75 75 75-33.648 75-75zM151 466v46h210v-46c0-57.89-47.11-105-105-105s-105 47.11-105 105zM481 496c0-41.352-33.648-75-75-75-7.758 0-15.094 1.523-22.137 3.719C388.11 437.813 391 451.512 391 466v46h90z"
                              fill="#1a4275"
                            />
                            <path
                              d="M466 361c0-33.09-26.91-60-60-60s-60 26.91-60 60c0 1.91.387 3.715.563 5.578 14.792 13.485 26.722 29.942 34.386 48.766C388.598 418.887 397.031 421 406 421c33.09 0 60-26.91 60-60zM165.438 366.578c.175-1.863.562-3.668.562-5.578 0-33.09-26.91-60-60-60s-60 26.91-60 60 26.91 60 60 60c8.969 0 17.402-2.113 25.05-5.652 7.665-18.828 19.595-35.286 34.387-48.77zM31 496v16h90v-46c0-14.488 2.89-28.188 7.137-41.281C121.094 422.523 113.757 421 106 421c-41.352 0-75 33.648-75 75z"
                              fill="#1a4275"
                            />
                          </g>
                        </svg>
                      </div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียดรอง 3.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message3_section2_index"]:
                              e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message3_section2_index"]}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div className="w-100 bg-secondary-light">
                      <div className="container mx-auto p-5 text-center">
                        <h5 className="fw-bold mb-3 text-primary">
                          {this.state[tab_ln + "_title_section2_index"]}
                        </h5>
                        <span className="text-secondary">
                          {this.state[tab_ln + "_message_section2_index"]}
                        </span>
                        <div className="row">
                          {this.state[tab_ln + "_title1_section2_index"] && (
                            <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                              <div className="p-3" style={{ minHeight: 212 }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="65"
                                  height="65"
                                  viewBox="0 0 100 100"
                                  xmlSpace="preserve"
                                  className="eco-icon"
                                >
                                  <g>
                                    <path
                                      d="m30.67 54.253 4.296 2.597c.7 0 1.099-.3 1.099-.899-.1-.6-.2-1.099-.5-1.598l-9.39-17.582-20.778.5c-.7-.1-1.399.5-1.399 1.199v.3c0 .2.3.499.9.898l4.195 2.498-4.695 7.092C3.299 50.757 2.7 52.455 2.5 54.253c.1 1.399.5 2.797 1.299 3.996l14.185 24.674c-.3-1.499-.5-2.897-.5-4.396 0-2.697.9-5.194 2.398-7.392zM36.065 39.868l11.687-18.08c-4.395-9.89-8.99-14.885-13.885-14.885-2.997 0-4.895.799-5.994 2.497L16.885 26.982z"
                                      fill="#1a4275"
                                    />
                                    <path
                                      d="M26.575 88.817H49.05V65.44H27.374a91.756 91.756 0 0 0-4.995 7.692c-1.099 1.998-1.598 4.296-1.698 6.593 0 5.994 1.898 9.09 5.894 9.09zM72.926 35.573l10.09-16.783c.299-.599.499-1.198.499-1.798 0-.799-.3-1.099-.8-1.099-.3.2-.699.3-.998.4l-4.596 1.898L72.926 10c-1.798-3.697-5.494-5.595-11.088-5.595H35.665c2.298.6 4.495 1.499 6.493 2.897 2.697 2.098 5.395 6.094 8.192 11.888l5.194 10.789-3.796 1.798c-.4.2-.6.599-.6.999 0 .599.4.999 1.2 1.098zM82.915 85.32 97.5 58.848c-1.898 2.298-4.295 3.996-6.993 4.995-2.797.8-5.794 1.099-8.69.999H65.534v-3.397c0-1.298-.3-1.997-1-1.997-.399 0-.798.2-.998.499l-10.09 17.781 10.59 16.383c.798 1.199 1.498 1.698 2.097 1.399.6-.2.9-.5.9-.9v-5.594h8.99a6.935 6.935 0 0 0 6.892-3.696z"
                                      fill="#1a4275"
                                    />
                                    <path
                                      d="M76.622 61.445h9.69c2.697-.1 5.294-1.198 7.192-3.096 2.697-2.098 3.996-4.396 3.996-6.693 0-1.199-.4-2.298-1.099-3.197L84.913 30.778 65.034 42.366z"
                                      fill="#1a4275"
                                    />
                                  </g>
                                </svg>
                                <h5 className="fw-bold my-3 text-primary">
                                  {
                                    this.state[
                                      tab_ln + "_title1_section2_index"
                                    ]
                                  }
                                </h5>
                                <span className="text-secondary">
                                  {
                                    this.state[
                                      tab_ln + "_message1_section2_index"
                                    ]
                                  }
                                </span>
                              </div>
                            </div>
                          )}
                          {this.state[tab_ln + "_title2_section2_index"] && (
                            <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                              <div className="p-3" style={{ minHeight: 212 }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="65"
                                  height="65"
                                  viewBox="0 0 512 512"
                                  xmlSpace="preserve"
                                >
                                  <g>
                                    <path
                                      d="M256 0C148.013 0 60.16 87.854 60.16 195.84S148.014 391.68 256 391.68s195.84-87.854 195.84-195.84S363.987 0 256 0zm91.899 322.328L256 278.839l-91.899 43.489 12.962-100.839-69.758-73.961 99.909-18.833L256 39.493l48.785 89.2 99.91 18.833-69.758 73.962z"
                                      fill="#1a4275"
                                    />
                                    <path
                                      d="M285.277 155.544 256 102.014l-29.277 53.53-59.958 11.302 41.864 44.386-7.779 60.516L256 245.649l55.15 26.099-7.779-60.516 41.864-44.386zM119.195 443.452a102.17 102.17 0 0 0 37.469-13.244v-31.435a224.341 224.341 0 0 1-37.469-23.214zM355.336 430.208a102.17 102.17 0 0 0 37.469 13.244v-67.893a224.407 224.407 0 0 1-37.469 23.214zM186.664 410.876V512c22.209-3.206 42.63-13.521 58.624-29.838L256 471.234l10.712 10.928c15.994 16.316 36.415 26.632 58.624 29.838V410.876C303.222 417.98 279.897 421.68 256 421.68s-47.222-3.7-69.336-10.804z"
                                      fill="#1a4275"
                                    />
                                  </g>
                                </svg>
                                <h5 className="fw-bold my-3 text-primary">
                                  {
                                    this.state[
                                      tab_ln + "_title2_section2_index"
                                    ]
                                  }
                                </h5>
                                <span className="text-secondary">
                                  {
                                    this.state[
                                      tab_ln + "_message2_section2_index"
                                    ]
                                  }
                                </span>
                              </div>
                            </div>
                          )}
                          {this.state[tab_ln + "_title3_section2_index"] && (
                            <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                              <div className="p-3" style={{ minHeight: 212 }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="65"
                                  height="65"
                                  viewBox="0 0 512 512"
                                  xmlSpace="preserve"
                                >
                                  <g>
                                    <path
                                      d="m256 143.75 56.277 29.59-10.75-62.668 45.559-44.399-62.945-9.14L256 0l-28.14 57.133-62.946 9.14 45.559 44.399-10.75 62.668zM446.137 159.129l-28.14-57.024-28.142 57.024-62.914 9.14 45.528 44.387-10.75 62.68 56.277-29.59 56.309 29.59-10.782-62.68L512 168.27zM48.477 212.656l-10.782 62.68 56.309-29.59 56.277 29.59-10.75-62.68 45.528-44.386-62.914-9.141-28.141-57.024-28.14 57.024L0 168.269zM331 286c0-41.352-33.648-75-75-75s-75 33.648-75 75 33.648 75 75 75 75-33.648 75-75zM151 466v46h210v-46c0-57.89-47.11-105-105-105s-105 47.11-105 105zM481 496c0-41.352-33.648-75-75-75-7.758 0-15.094 1.523-22.137 3.719C388.11 437.813 391 451.512 391 466v46h90z"
                                      fill="#1a4275"
                                    />
                                    <path
                                      d="M466 361c0-33.09-26.91-60-60-60s-60 26.91-60 60c0 1.91.387 3.715.563 5.578 14.792 13.485 26.722 29.942 34.386 48.766C388.598 418.887 397.031 421 406 421c33.09 0 60-26.91 60-60zM165.438 366.578c.175-1.863.562-3.668.562-5.578 0-33.09-26.91-60-60-60s-60 26.91-60 60 26.91 60 60 60c8.969 0 17.402-2.113 25.05-5.652 7.665-18.828 19.595-35.286 34.387-48.77zM31 496v16h90v-46c0-14.488 2.89-28.188 7.137-41.281C121.094 422.523 113.757 421 106 421c-41.352 0-75 33.648-75 75z"
                                      fill="#1a4275"
                                    />
                                  </g>
                                </svg>
                                <h5 className="fw-bold my-3 text-primary">
                                  {
                                    this.state[
                                      tab_ln + "_title3_section2_index"
                                    ]
                                  }
                                </h5>
                                <span className="text-secondary">
                                  {
                                    this.state[
                                      tab_ln + "_message3_section2_index"
                                    ]
                                  }
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Section 3 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 3</h3>
                  <div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">รูปภาพ</div>
                      <div className="d-flex flex-wrap">
                        <input
                          hidden
                          accept="image/*"
                          id="photo_section3_index"
                          type="file"
                          onChange={async (e) => {
                            loading(true);
                            const file = e.target.files[0];
                            if (!file) return;

                            const reader = new FileReader();
                            reader.onloadend = async () => {
                              const base64 = reader.result;
                              console.log(base64); // ✅ base64
                              // setState(base64) หรือส่งไป API ได้เลย
                              const formdata = new FormData();
                              formdata.append("image", base64.split(",")[1]);

                              const response = await fetch(
                                "https://api.imgbb.com/1/upload?key=" +
                                  process.env.REACT_APP_IMGBB_KEY,
                                {
                                  method: "POST",
                                  body: formdata,
                                }
                              );

                              const result = await response.json();

                              this.setState({
                                photo_section3_index: result.data.image.url,
                              });
                              loading(false);
                            };
                            reader.readAsDataURL(file);

                            e.target.value = "";
                            e.target.files = null;
                          }}
                        />
                        {photo_section3_index ? (
                          <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                            <img
                              alt="example"
                              src={photo_section3_index}
                              className="rounded-3"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <span
                              className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                              style={{ right: -12, top: -12 }}
                              onClick={() => {
                                this.setState({ photo_section3_index: "" });
                              }}
                            >
                              {"\uf00d"}
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex">
                            <div
                              className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                              onClick={() => {
                                document
                                  .getElementById("photo_section3_index")
                                  .click();
                              }}
                            >
                              {"\uf03e"}
                            </div>
                            <small className="text-secondary ps-3">
                              <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                              เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                              <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                              <br />
                              <b>ขนาดไฟล์สูงสุด:</b> 5MB
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-130 mb-2">หัวข้อหลัก</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อหลัก.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_section3_index"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_section3_index"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-130 mb-2">รายละเอียดหลัก</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียดหลัก.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_section3_index"]:
                              e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_section3_index"]}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div className="w-100 bg-light">
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-6">
                          <div
                            className="d-none d-md-block position-relative align-content-center"
                            style={{
                              minHeight: 600,
                              backgroundImage: `
                                linear-gradient(to left,
                                  rgba(248,249,250,1),
                                  rgba(248,249,250,0.2),
                                  rgba(248,249,250,0),
                                  rgba(248,249,250,0)
                                ),
                                url(${photo_section3_index || THUMBNAIL})
                              `,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                          <div
                            className="d-block d-md-none position-relative align-content-center"
                            style={{
                              minHeight: 600,
                              backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(248,249,250,1),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,1)
                      ),
                      url(${photo_section3_index || THUMBNAIL})
                    `,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                        </div>

                        <div className="col-12 col-md-6 col-lg-6 text-start px-5">
                          <div className="my-5 py-4">
                            <h2 className="fw-bold mb-4">
                              {this.state[tab_ln + "_title_section3_index"]}
                            </h2>
                            <div className="text-secondary">
                              {this.state[tab_ln + "_message_section3_index"]}
                            </div>
                            <a className="btn btn-dark px-4 mt-4" href="/about">
                              {global.i18[tab_ln]?.["อ่านเพิ่มเติม"]}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Section 4 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 4</h3>
                  <div className="w-100 mb-2">
                    <div className="w-100">
                      <input
                        hidden
                        accept="image/*"
                        id="photo_section4_index"
                        type="file"
                        onChange={async (e) => {
                          loading(true);
                          const file = e.target.files[0];
                          if (!file) return;

                          const reader = new FileReader();
                          reader.onloadend = async () => {
                            const base64 = reader.result;
                            console.log(base64); // ✅ base64
                            // setState(base64) หรือส่งไป API ได้เลย
                            const formdata = new FormData();
                            formdata.append("image", base64.split(",")[1]);

                            const response = await fetch(
                              "https://api.imgbb.com/1/upload?key=" +
                                process.env.REACT_APP_IMGBB_KEY,
                              {
                                method: "POST",
                                body: formdata,
                              }
                            );

                            const result = await response.json();

                            this.setState({
                              photo_section4_index: [
                                ...photo_section4_index,
                                {
                                  image: result.data.image.url,
                                  th: { title: "", description: "" },
                                  us: { title: "", description: "" },
                                  jp: { title: "", description: "" },
                                  cn: { title: "", description: "" },
                                },
                              ],
                            });
                            loading(false);
                          };
                          reader.readAsDataURL(file);

                          e.target.value = "";
                          e.target.files = null;
                        }}
                      />
                      {photo_section4_index?.length !== 0 && (
                        <div className="w-100">
                          {photo_section4_index?.map((item, index) => (
                            <div className="card rounded-3 bg-secondary-light p-2 w-100 mb-2 shadow-sm position-relative">
                              <div className="d-flex">
                                <div className="hpx-100 wpx-100 rounded-3 border p-1 me-2 mb-3">
                                  <img
                                    alt="example"
                                    src={item.image}
                                    className="rounded-3"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                                <div className="w-100">
                                  <input
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder="หัวข้อ.."
                                    onChange={(e) => {
                                      photo_section4_index[index][
                                        tab_ln
                                      ].title = e.target.value;
                                      this.setState({ photo_section4_index });
                                    }}
                                    value={item[tab_ln].title}
                                  />
                                  <textarea
                                    className="form-control"
                                    placeholder="รายละเอียด.."
                                    rows={5}
                                    onChange={(e) => {
                                      photo_section4_index[index][
                                        tab_ln
                                      ].description = e.target.value;
                                      this.setState({ photo_section4_index });
                                    }}
                                    value={item[tab_ln].description}
                                  />
                                </div>
                              </div>

                              <span
                                className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -8, top: -8 }}
                                onClick={() => {
                                  photo_section4_index.splice(index, 1);
                                  this.setState({ photo_section4_index });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ))}
                          <button
                            className="btn btn-dark px-4"
                            onClick={() => {
                              document
                                .getElementById("photo_section4_index")
                                .click();
                            }}
                          >
                            เพิ่มรูปภาพ
                          </button>
                        </div>
                      )}
                      {photo_section4_index?.length === 0 && (
                        <div className="d-flex">
                          <div
                            className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                            onClick={() => {
                              document
                                .getElementById("photo_section4_index")
                                .click();
                            }}
                          >
                            {"\uf03e"}
                          </div>
                          <small className="text-secondary ps-3">
                            <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล
                            เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                            <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                            <br />
                            <b>ขนาดไฟล์สูงสุด:</b> 5MB
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div className="w-100 bg-secondary-light align-content-center">
                      <div className="row container mx-auto mt-5 mb-2 justify-content-center">
                        {photo_section4_index.map((item, index) => (
                          <div className={"col-12 col-sm-6 col-lg-4 mb-3"}>
                            <div
                              className="w-100 position-relative rounded-3 overflow-hidden mb-3 shadow-sm popup pointer px-4 px-xl-5 py-5"
                              style={{
                                backgroundImage: `
                                linear-gradient(to bottom,
                                  rgba(0,0,0,1),
                                  rgba(0,0,0,0.2),
                                  rgba(0,0,0,0),
                                  rgba(0,0,0,0)
                                ),
                                url(${item.image || THUMBNAIL})
                              `,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                height: 600,
                              }}
                            >
                              <h3
                                className="fw-bold w-100 overflow-hidden mb-2 text-nowrap text-light"
                                style={{ textOverflow: "ellipsis" }}
                              >
                                {item[`${tab_ln}`]?.title ||
                                  item.th?.title ||
                                  ""}
                              </h3>
                              <span
                                className="text-light"
                                style={{
                                  display: "-webkit-box",
                                  WebkitLineClamp: 3,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                }}
                              >
                                {item[`${tab_ln}`]?.description ||
                                  item.th?.description ||
                                  ""}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Section 5 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 5</h3>
                  <div>
                    <div className="d-flex mb-2">
                      <div className="wpx-130 mb-2">รูปภาพ</div>
                      <div className="d-flex flex-wrap">
                        <input
                          hidden
                          accept="image/*"
                          id="photo_section5_index"
                          type="file"
                          onChange={async (e) => {
                            loading(true);
                            const file = e.target.files[0];
                            if (!file) return;

                            const reader = new FileReader();
                            reader.onloadend = async () => {
                              const base64 = reader.result;
                              console.log(base64); // ✅ base64
                              // setState(base64) หรือส่งไป API ได้เลย
                              const formdata = new FormData();
                              formdata.append("image", base64.split(",")[1]);

                              const response = await fetch(
                                "https://api.imgbb.com/1/upload?key=" +
                                  process.env.REACT_APP_IMGBB_KEY,
                                {
                                  method: "POST",
                                  body: formdata,
                                }
                              );

                              const result = await response.json();

                              this.setState({
                                photo_section5_index: result.data.image.url,
                              });
                              loading(false);
                            };
                            reader.readAsDataURL(file);

                            e.target.value = "";
                            e.target.files = null;
                          }}
                        />
                        {photo_section5_index ? (
                          <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                            <img
                              alt="example"
                              src={photo_section5_index}
                              className="rounded-3"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <span
                              className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                              style={{ right: -12, top: -12 }}
                              onClick={() => {
                                this.setState({ photo_section5_index: "" });
                              }}
                            >
                              {"\uf00d"}
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex">
                            <div
                              className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                              onClick={() => {
                                document
                                  .getElementById("photo_section5_index")
                                  .click();
                              }}
                            >
                              {"\uf03e"}
                            </div>
                            <small className="text-secondary ps-3">
                              <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                              เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                              <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                              <br />
                              <b>ขนาดไฟล์สูงสุด:</b> 5MB
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-130 mb-2">หัวข้อหลัก</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อหลัก.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_section5_index"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_section5_index"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-130 mb-2">รายละเอียดหลัก</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียดหลัก.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_section5_index"]:
                              e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_section5_index"]}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div className="w-100 bg-light">
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 text-start px-5">
                          <div className="my-5 py-4">
                            <h2 className="fw-bold mb-4">
                              {this.state[tab_ln + "_title_section5_index"]}
                            </h2>
                            <div className="text-secondary">
                              {this.state[tab_ln + "_message_section5_index"]}
                            </div>
                            <a className="btn btn-dark px-4 mt-4" href="/about">
                              {global.i18[tab_ln]?.["อ่านเพิ่มเติม"]}
                            </a>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6">
                          <div
                            className="d-none d-md-block position-relative align-content-center"
                            style={{
                              minHeight: 600,
                              backgroundImage: `
                    linear-gradient(to right,
                      rgba(248,249,250,1),
                      rgba(248,249,250,0.2),
                      rgba(248,249,250,0),
                      rgba(248,249,250,0)
                    ),
                    url(${photo_section5_index || THUMBNAIL})
                  `,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                          <div
                            className="d-block d-md-none position-relative align-content-center"
                            style={{
                              minHeight: 600,
                              backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(248,249,250,1),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,1)
                      ),
                      url(${photo_section5_index || THUMBNAIL})
                    `,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Section 6 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 6</h3>
                  <div className="w-100 mb-2">
                    <div className="row">
                      {howto_section6_index?.length !== 0 &&
                        howto_section6_index?.map((item, index) => (
                          <div className="col-12 col-md-6">
                            <div className="card rounded-3 bg-secondary-light p-2 w-100 mb-2 shadow-sm position-relative">
                              <div className="w-100">
                                <div className="d-flex">
                                  <div className="wpx-40 hpx-40 d-flex align-items-center justify-content-center rounded-circle bg-primary text-light fw-bold me-2">
                                    {index + 1}
                                  </div>
                                  <input
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder="หัวข้อ.."
                                    onChange={(e) => {
                                      howto_section6_index[index][
                                        tab_ln
                                      ].title = e.target.value;
                                      this.setState({ howto_section6_index });
                                    }}
                                    value={item[tab_ln].title}
                                  />
                                </div>
                                <textarea
                                  className="form-control"
                                  placeholder="รายละเอียด.."
                                  rows={5}
                                  onChange={(e) => {
                                    howto_section6_index[index][
                                      tab_ln
                                    ].description = e.target.value;
                                    this.setState({ howto_section6_index });
                                  }}
                                  value={item[tab_ln].description}
                                />
                              </div>

                              <span
                                className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -8, top: -8 }}
                                onClick={() => {
                                  howto_section6_index.splice(index, 1);
                                  this.setState({ howto_section6_index });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          </div>
                        ))}
                      <button
                        className="btn btn-dark px-4"
                        onClick={() => {
                          this.setState({
                            howto_section6_index: [
                              ...howto_section6_index,
                              {
                                th: { title: "", description: "" },
                                us: { title: "", description: "" },
                                jp: { title: "", description: "" },
                                cn: { title: "", description: "" },
                              },
                            ],
                          });
                        }}
                      >
                        เพิ่มวิธีใช้งาน
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div className="w-100 bg-light align-content-center">
                      <div className="container px-4 my-5 text-center">
                        <h2 className="fw-bold mb-0 mx-3">
                          วิธีการใช้งานของเรา - เตาเผาขยะชุมชน
                        </h2>
                      </div>
                      <div className="container">
                        <div className="row pb-5">
                          {howto_section6_index?.map((item, index) => (
                            <div className="col-6 col-lg-3 mb-3 p-1">
                              <div className="rounded-3 bg-secondary-light hpx-200 p-3">
                                <div className="d-flex align-items-center justify-content-center fw-bold wpx-50 hpx-50 rounded-circle bg-primary text-white mb-2 text-28">
                                  {index + 1}
                                </div>
                                <h5 className="mt-2 fw-bold">
                                  {item[`${tab_ln}`]?.title ||
                                    item.th?.title ||
                                    ""}
                                </h5>
                                <span>
                                  {item[`${tab_ln}`]?.description ||
                                    item.th?.description ||
                                    ""}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Section 7 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 7</h3>
                  <div className="w-100 mb-2">
                    <div className="w-100">
                      <input
                        hidden
                        accept="image/*"
                        id="customer_section7_index"
                        type="file"
                        onChange={async (e) => {
                          loading(true);
                          const file = e.target.files[0];
                          if (!file) return;

                          const reader = new FileReader();
                          reader.onloadend = async () => {
                            const base64 = reader.result;
                            console.log(base64); // ✅ base64
                            // setState(base64) หรือส่งไป API ได้เลย
                            const formdata = new FormData();
                            formdata.append("image", base64.split(",")[1]);

                            const response = await fetch(
                              "https://api.imgbb.com/1/upload?key=" +
                                process.env.REACT_APP_IMGBB_KEY,
                              {
                                method: "POST",
                                body: formdata,
                              }
                            );

                            const result = await response.json();

                            this.setState({
                              customer_section7_index: [
                                ...customer_section7_index,
                                {
                                  image: result.data.image.url,
                                  th: { title: "", description: "" },
                                  us: { title: "", description: "" },
                                  jp: { title: "", description: "" },
                                  cn: { title: "", description: "" },
                                },
                              ],
                            });
                            loading(false);
                          };
                          reader.readAsDataURL(file);

                          e.target.value = "";
                          e.target.files = null;
                        }}
                      />
                      {customer_section7_index?.length !== 0 && (
                        <div className="w-100">
                          {customer_section7_index?.map((item, index) => (
                            <div className="card rounded-3 bg-secondary-light p-2 w-100 mb-2 shadow-sm position-relative">
                              <div className="d-flex">
                                <div className="hpx-100 wpx-100 rounded-3 border p-1 me-2 mb-3">
                                  <img
                                    alt="example"
                                    src={item.image}
                                    className="rounded-3"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                                <div className="w-100">
                                  <input
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder="หัวข้อ.."
                                    onChange={(e) => {
                                      customer_section7_index[index][
                                        tab_ln
                                      ].title = e.target.value;
                                      this.setState({
                                        customer_section7_index,
                                      });
                                    }}
                                    value={item[tab_ln].title}
                                  />
                                  <textarea
                                    className="form-control"
                                    placeholder="รายละเอียด.."
                                    rows={5}
                                    onChange={(e) => {
                                      customer_section7_index[index][
                                        tab_ln
                                      ].description = e.target.value;
                                      this.setState({
                                        customer_section7_index,
                                      });
                                    }}
                                    value={item[tab_ln].description}
                                  />
                                </div>
                              </div>

                              <span
                                className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -8, top: -8 }}
                                onClick={() => {
                                  customer_section7_index.splice(index, 1);
                                  this.setState({ customer_section7_index });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ))}
                          <button
                            className="btn btn-dark px-4"
                            onClick={() => {
                              document
                                .getElementById("customer_section7_index")
                                .click();
                            }}
                          >
                            เพิ่มกลุ่มลูกค้า
                          </button>
                        </div>
                      )}
                      {customer_section7_index?.length === 0 && (
                        <div className="d-flex">
                          <div
                            className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                            onClick={() => {
                              document
                                .getElementById("customer_section7_index")
                                .click();
                            }}
                          >
                            {"\uf03e"}
                          </div>
                          <small className="text-secondary ps-3">
                            <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล
                            เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                            <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                            <br />
                            <b>ขนาดไฟล์สูงสุด:</b> 5MB
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div className="w-100 bg-light align-content-center">
                      <div className="container px-4 my-5 text-center">
                        <h2 className="fw-bold mb-0 mx-3">กลุ่มลูกค้าของเรา</h2>
                        <div className="text-secondary">
                          เตาเผาขยะชุมชนของ ACI Incinerator
                          ได้รับการออกแบบเพื่อตอบโจทย์การใช้งานที่หลากหลาย
                          เหมาะกับทั้งภาครัฐ ภาคเอกชน และชุมชน
                          ที่ต้องการจัดการขยะอย่างมีประสิทธิภาพและเป็นมิตรต่อสิ่งแวดล้อม
                        </div>
                      </div>
                      <div className="container">
                        <div className="row pb-5 justify-content-center">
                          {customer_section7_index?.map((item, index) => (
                            <div className="col-6 col-md-4 col-xl-3 mb-3 p-1">
                              <div className="rounded-3 bg-secondary-light h-100 p-3">
                                <img
                                  alt="LOGO"
                                  src={item.image || THUMBNAIL}
                                  className="hpx-200 w-100 mx-auto"
                                  style={{ objectFit: "cover" }}
                                  loading="lazy"
                                />
                                <h5 className="mt-2 fw-bold">
                                  {item[tab_ln]?.title || item.th?.title || ""}
                                </h5>
                                <span className="text-secondary">
                                  {item[tab_ln]?.description ||
                                    item.th?.description ||
                                    ""}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {tab === "เกี่ยวกับเรา" && (
              <div className="row">
                {/* Section 1 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 1</h3>
                  <div className="w-100">
                    <div className="d-flex mb-2">
                      <div className="wpx-100 mb-2">รูปภาพ</div>
                      <div className="d-flex flex-wrap">
                        <input
                          hidden
                          accept="image/*"
                          id="photo_about"
                          type="file"
                          onChange={async (e) => {
                            loading(true);
                            const file = e.target.files[0];
                            if (!file) return;

                            const reader = new FileReader();
                            reader.onloadend = async () => {
                              const base64 = reader.result;
                              console.log(base64); // ✅ base64
                              // setState(base64) หรือส่งไป API ได้เลย
                              const formdata = new FormData();
                              formdata.append("image", base64.split(",")[1]);

                              const response = await fetch(
                                "https://api.imgbb.com/1/upload?key=" +
                                  process.env.REACT_APP_IMGBB_KEY,
                                {
                                  method: "POST",
                                  body: formdata,
                                }
                              );

                              const result = await response.json();

                              this.setState({
                                photo_about: result.data.image.url,
                              });
                              loading(false);
                            };
                            reader.readAsDataURL(file);

                            e.target.value = "";
                            e.target.files = null;
                          }}
                        />
                        {photo_about ? (
                          <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                            <img
                              alt="example"
                              src={photo_about}
                              className="rounded-3"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <span
                              className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                              style={{ right: -12, top: -12 }}
                              onClick={() => {
                                this.setState({ photo_about: "" });
                              }}
                            >
                              {"\uf00d"}
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex">
                            <div
                              className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                              onClick={() => {
                                document.getElementById("photo_about").click();
                              }}
                            >
                              {"\uf03e"}
                            </div>
                            <small className="text-secondary ps-3">
                              <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                              เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                              <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                              <br />
                              <b>ขนาดไฟล์สูงสุด:</b> 5MB
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">หัวข้อ</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อ.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_about"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_about"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">รายละเอียด</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียด.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_about"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_about"]}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div
                      className="overflow-scroll w-100 bg-light"
                      style={{ maxHeight: "70vh" }}
                    >
                      {/* SECTION 2 */}
                      <div className="row bg-secondary-light">
                        <div className="col-12 col-md-6 col-lg-6">
                          <div
                            className="d-none d-md-block position-relative align-content-center"
                            style={{
                              minHeight: 600,
                              backgroundImage: `
          linear-gradient(to left,
            rgba(234, 236, 243,1),
            rgba(234, 236, 243,0.2),
            rgba(234, 236, 243,0),
            rgba(234, 236, 243,0)
          ),
          url(${photo_about || THUMBNAIL})
        `,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                          <div
                            className="d-block d-md-none position-relative align-content-center"
                            style={{
                              minHeight: 600,
                              backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(234, 236, 243,1),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,1)
                      ),
                      url(${photo_about || THUMBNAIL})
                    `,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                        </div>

                        <div className="col-12 col-md-6 col-lg-6 text-start px-5">
                          <div className="my-5 py-4">
                            <h2 className="fw-bold mb-4">
                              {this.state[tab_ln + "_title_about"] ||
                                th_title_about}
                            </h2>
                            <div className="text-secondary">
                              {this.state[tab_ln + "_message_about"] ||
                                th_message_about}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Section 2 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 2</h3>
                  <div className="w-100">
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">หัวข้อ 2</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อ 2.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_about_2"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_about_2"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">รายละเอียด 2</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียด 2.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_about_2"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_about_2"]}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div className="py-5 px-4">
                      <div className="bg-primary-light p-4 rounded-4">
                        <h4 className="fw-bold mb-2 text-primary text-center">
                          {" "}
                          {this.state[tab_ln + "_title_about_2"] ||
                            th_title_about_2}
                        </h4>
                        <div className="text-secondary px-4">
                          {(
                            this.state[tab_ln + "_message_about_2"] ||
                            th_message_about_2
                          )
                            ?.split("\n")
                            .map((item) => (
                              <div>{item}</div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Section 3 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 3</h3>
                  <div className="w-100 mb-2">
                    <div className="w-100">
                      <input
                        hidden
                        accept="image/*"
                        id="photo_about_3"
                        type="file"
                        onChange={async (e) => {
                          loading(true);
                          const file = e.target.files[0];
                          if (!file) return;

                          const reader = new FileReader();
                          reader.onloadend = async () => {
                            const base64 = reader.result;
                            console.log(base64); // ✅ base64
                            // setState(base64) หรือส่งไป API ได้เลย
                            const formdata = new FormData();
                            formdata.append("image", base64.split(",")[1]);

                            const response = await fetch(
                              "https://api.imgbb.com/1/upload?key=" +
                                process.env.REACT_APP_IMGBB_KEY,
                              {
                                method: "POST",
                                body: formdata,
                              }
                            );

                            const result = await response.json();

                            this.setState({
                              photo_about_3: [
                                ...photo_about_3,
                                {
                                  image: result.data.image.url,
                                  th: {
                                    year: "",
                                    detail: "",
                                    title: "",
                                    description: "",
                                  },
                                  us: {
                                    year: "",
                                    detail: "",
                                    title: "",
                                    description: "",
                                  },
                                  jp: {
                                    year: "",
                                    detail: "",
                                    title: "",
                                    description: "",
                                  },
                                  cn: {
                                    year: "",
                                    detail: "",
                                    title: "",
                                    description: "",
                                  },
                                },
                              ],
                            });
                            loading(false);
                          };
                          reader.readAsDataURL(file);

                          e.target.value = "";
                          e.target.files = null;
                        }}
                      />
                      {photo_about_3.length !== 0 && (
                        <div className="w-100">
                          {photo_about_3?.map((item, index) => (
                            <div className="card rounded-3 bg-secondary-light p-2 w-100 mb-2 shadow-sm position-relative">
                              <div className="d-flex">
                                <div className="hpx-100 wpx-100 rounded-3 border p-1 me-2 mb-3">
                                  <img
                                    alt="example"
                                    src={item.image}
                                    className="rounded-3"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                                <div className="w-100">
                                  <div className="row">
                                    <div className="col-6">
                                      <input
                                        type="text"
                                        className="form-control mb-2"
                                        placeholder="ปี.."
                                        onChange={(e) => {
                                          photo_about_3[index][tab_ln].year =
                                            e.target.value;
                                          this.setState({ photo_about_3 });
                                        }}
                                        value={item[tab_ln].year}
                                      />
                                    </div>
                                    <div className="col-6">
                                      <input
                                        type="text"
                                        className="form-control mb-2"
                                        placeholder="ข้อความ.."
                                        onChange={(e) => {
                                          photo_about_3[index][tab_ln].detail =
                                            e.target.value;
                                          this.setState({ photo_about_3 });
                                        }}
                                        value={item[tab_ln].detail}
                                      />
                                    </div>
                                  </div>
                                  <input
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder="หัวข้อ.."
                                    onChange={(e) => {
                                      photo_about_3[index][tab_ln].title =
                                        e.target.value;
                                      this.setState({ photo_about_3 });
                                    }}
                                    value={item[tab_ln].title}
                                  />
                                  <textarea
                                    className="form-control"
                                    placeholder="ข้อความปก.."
                                    rows={5}
                                    onChange={(e) => {
                                      photo_about_3[index][tab_ln].description =
                                        e.target.value;
                                      this.setState({ photo_about_3 });
                                    }}
                                    value={item[tab_ln].description}
                                  />
                                </div>
                              </div>

                              <span
                                className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                                style={{ right: -8, top: -8 }}
                                onClick={() => {
                                  photo_about_3.splice(index, 1);
                                  this.setState({ photo_about_3 });
                                }}
                              >
                                {"\uf00d"}
                              </span>
                            </div>
                          ))}
                          <button
                            className="btn btn-dark px-4"
                            onClick={() => {
                              document.getElementById("photo_about_3").click();
                            }}
                          >
                            เพิ่มไทม์ไลน์
                          </button>
                        </div>
                      )}
                      {photo_about_3.length === 0 && (
                        <div className="d-flex">
                          <div
                            className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                            onClick={() => {
                              document.getElementById("photo_about_3").click();
                            }}
                          >
                            {"\uf03e"}
                          </div>
                          <small className="text-secondary ps-3">
                            <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล
                            เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                            <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                            <br />
                            <b>ขนาดไฟล์สูงสุด:</b> 5MB
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div
                      className="overflow-scroll w-100 bg-secondary-light"
                      style={{ maxHeight: "70vh" }}
                    >
                      {/* SECTION 2 */}
                      {photo_about_3.map((item, index) => (
                        <div className="d-flex">
                          <div className="w-100 p-4 d-none d-md-block">
                            {index % 2 === 1 ? (
                              <div className="rounded-4 bg-light p-3 text-end">
                                <h5 className="fw-bold text-primary">
                                  {item[tab_ln]?.title || item.th.title}
                                </h5>
                                <img
                                  alt="example"
                                  src={item.image}
                                  className="w-100 my-3"
                                  style={{
                                    objectFit: "cover",
                                  }}
                                />
                                <span>
                                  {item[tab_ln]?.description ||
                                    item.th.description}
                                </span>
                              </div>
                            ) : (
                              <div className="text-end">
                                <h5 className="fw-bold text-primary">
                                  {item[tab_ln]?.year || item.th.year}
                                </h5>
                                <span>
                                  {item[tab_ln]?.detail || item.th.detail}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="wpx-60">
                            {index === 0 && (
                              <div
                                className="hpx-10 wpx-10 rounded-circle mx-auto"
                                style={{
                                  backgroundColor: "#9f9f9f",
                                  height: 8,
                                }}
                              ></div>
                            )}
                            <div
                              className="hpx-20 mx-auto"
                              style={{ width: 4, backgroundColor: "#9f9f9f" }}
                            ></div>
                            <div
                              className="hpx-60 wpx-60 rounded-circle mx-auto d-flex align-items-center justify-content-center p-1"
                              style={{ backgroundColor: "#9f9f9f" }}
                            >
                              <div className="w-100 h-100 rounded-circle bg-primary mx-auto d-flex align-items-center justify-content-center">
                                <span className="icon text-light text-36">
                                  {"\uf017"}
                                </span>
                              </div>
                            </div>
                            <div
                              className="h-100 mx-auto"
                              style={{ width: 4, backgroundColor: "#9f9f9f" }}
                            ></div>
                            {index === photo_about_3.length - 1 && (
                              <div
                                className="hpx-10 wpx-10 rounded-circle mx-auto"
                                style={{ backgroundColor: "#9f9f9f" }}
                              ></div>
                            )}
                          </div>
                          <div className="w-100 p-4">
                            {index % 2 === 0 ? (
                              <div className="rounded-4 bg-light p-3">
                                <div className="d-block d-md-none mb-2">
                                  <h5 className="fw-bold text-primary mb-1">
                                    {item[tab_ln]?.year || item.th.year}
                                  </h5>
                                  <span>
                                    {item[tab_ln]?.detail || item.th.detail}
                                  </span>
                                </div>
                                <h5 className="fw-bold text-primary">
                                  {item[tab_ln]?.title || item.th.title}
                                </h5>
                                <img
                                  alt="example"
                                  src={item.image}
                                  className="w-100 my-3"
                                  style={{
                                    objectFit: "cover",
                                  }}
                                />
                                <span>
                                  {item[tab_ln]?.description ||
                                    item.th.description}
                                </span>
                              </div>
                            ) : (
                              <div>
                                <div className="d-none d-md-block">
                                  <h5 className="fw-bold text-primary">
                                    {item[tab_ln]?.year || item.th.year}
                                  </h5>
                                  <span>
                                    {item[tab_ln]?.detail || item.th.detail}
                                  </span>
                                </div>
                                <div className="rounded-4 bg-light p-3 d-block d-md-none">
                                  <div className="d-block d-md-none mb-2">
                                    <h5 className="fw-bold text-primary mb-1">
                                      {item[tab_ln]?.year || item.th.year}
                                    </h5>
                                    <span>
                                      {item[tab_ln]?.detail || item.th.detail}
                                    </span>
                                  </div>
                                  <h5 className="fw-bold text-primary">
                                    {item[tab_ln]?.title || item.th.title}
                                  </h5>
                                  <img
                                    alt="example"
                                    src={item.image}
                                    className="w-100 my-3"
                                    style={{
                                      objectFit: "cover",
                                    }}
                                  />
                                  <span>
                                    {item[tab_ln]?.description ||
                                      item.th.description}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* Section 4 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 4</h3>
                  <div className="w-100">
                    <div className="d-flex mb-2">
                      <div className="wpx-100 mb-2">รูปภาพ</div>
                      <div className="d-flex flex-wrap">
                        <input
                          hidden
                          accept="image/*"
                          id="photo_about_4"
                          type="file"
                          onChange={async (e) => {
                            loading(true);
                            const file = e.target.files[0];
                            if (!file) return;

                            const reader = new FileReader();
                            reader.onloadend = async () => {
                              const base64 = reader.result;
                              console.log(base64); // ✅ base64
                              // setState(base64) หรือส่งไป API ได้เลย
                              const formdata = new FormData();
                              formdata.append("image", base64.split(",")[1]);

                              const response = await fetch(
                                "https://api.imgbb.com/1/upload?key=" +
                                  process.env.REACT_APP_IMGBB_KEY,
                                {
                                  method: "POST",
                                  body: formdata,
                                }
                              );

                              const result = await response.json();

                              this.setState({
                                photo_about_4: result.data.image.url,
                              });
                              loading(false);
                            };
                            reader.readAsDataURL(file);

                            e.target.value = "";
                            e.target.files = null;
                          }}
                        />
                        {photo_about_4 ? (
                          <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                            <img
                              alt="example"
                              src={photo_about_4}
                              className="rounded-3"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <span
                              className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                              style={{ right: -12, top: -12 }}
                              onClick={() => {
                                this.setState({ photo_about_4: "" });
                              }}
                            >
                              {"\uf00d"}
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex">
                            <div
                              className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                              onClick={() => {
                                document
                                  .getElementById("photo_about_4")
                                  .click();
                              }}
                            >
                              {"\uf03e"}
                            </div>
                            <small className="text-secondary ps-3">
                              <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                              เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                              <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                              <br />
                              <b>ขนาดไฟล์สูงสุด:</b> 5MB
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">หัวข้อ</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อ.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_about_4"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_about_4"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">รายละเอียด</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียด.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_about_4"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_about_4"]}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div
                      className="overflow-scroll w-100 bg-light"
                      style={{ maxHeight: "70vh" }}
                    >
                      {/* SECTION 2 */}
                      <div className="row bg-secondary-light">
                        <div className="col-12 col-md-6 col-lg-6 text-start px-5">
                          <div className="my-5 py-4">
                            <h2 className="fw-bold mb-4">
                              {this.state[tab_ln + "_title_about_4"] ||
                                th_title_about_4}
                            </h2>
                            <div className="text-secondary">
                              {this.state[tab_ln + "_message_about_4"] ||
                                th_message_about_4}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6">
                          <div
                            className="d-none d-md-block position-relative align-content-center"
                            style={{
                              minHeight: 600,
                              backgroundImage: `
          linear-gradient(to right,
            rgba(234, 236, 243,1),
            rgba(234, 236, 243,0.2),
            rgba(234, 236, 243,0),
            rgba(234, 236, 243,0)
          ),
          url(${photo_about_4 || THUMBNAIL})
        `,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                          <div
                            className="d-block d-md-none position-relative align-content-center"
                            style={{
                              minHeight: 600,
                              backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(234, 236, 243,1),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,1)
                      ),
                      url(${photo_about_4 || THUMBNAIL})
                    `,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Section 5 */}
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">Section 5</h3>
                  <div className="w-100">
                    <div className="d-flex mb-2">
                      <div className="wpx-100 mb-2">รูปภาพ</div>
                      <div className="d-flex flex-wrap">
                        <input
                          hidden
                          accept="image/*"
                          id="photo_about_5"
                          type="file"
                          onChange={async (e) => {
                            loading(true);
                            const file = e.target.files[0];
                            if (!file) return;

                            const reader = new FileReader();
                            reader.onloadend = async () => {
                              const base64 = reader.result;
                              console.log(base64); // ✅ base64
                              // setState(base64) หรือส่งไป API ได้เลย
                              const formdata = new FormData();
                              formdata.append("image", base64.split(",")[1]);

                              const response = await fetch(
                                "https://api.imgbb.com/1/upload?key=" +
                                  process.env.REACT_APP_IMGBB_KEY,
                                {
                                  method: "POST",
                                  body: formdata,
                                }
                              );

                              const result = await response.json();

                              this.setState({
                                photo_about_5: result.data.image.url,
                              });
                              loading(false);
                            };
                            reader.readAsDataURL(file);

                            e.target.value = "";
                            e.target.files = null;
                          }}
                        />
                        {photo_about_5 ? (
                          <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                            <img
                              alt="example"
                              src={photo_about_5}
                              className="rounded-3"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <span
                              className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                              style={{ right: -12, top: -12 }}
                              onClick={() => {
                                this.setState({ photo_about_5: "" });
                              }}
                            >
                              {"\uf00d"}
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex">
                            <div
                              className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                              onClick={() => {
                                document
                                  .getElementById("photo_about_5")
                                  .click();
                              }}
                            >
                              {"\uf03e"}
                            </div>
                            <small className="text-secondary ps-3">
                              <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                              เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                              <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                              <br />
                              <b>ขนาดไฟล์สูงสุด:</b> 5MB
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">หัวข้อ</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อ.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_about_5"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_about_5"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">รายละเอียด</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียด.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_about_5"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_about_5"]}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div
                      className="overflow-scroll w-100 bg-light"
                      style={{ maxHeight: "70vh" }}
                    >
                      {/* SECTION 2 */}
                      <div className="container text-center">
                        <div className="my-5 py-4">
                          <h2 className="fw-bold mb-4">
                            {this.state[tab_ln + "_title_about_5"] ||
                              th_title_about_5}
                          </h2>
                          <div className="text-secondary mb-4">
                            {this.state[tab_ln + "_message_about_5"] ||
                              th_message_about_5}
                          </div>
                          <img
                            alt="THUMBNAIL"
                            src={photo_about_5 || THUMBNAIL}
                            className="h-100 w-100 rounded-3"
                            style={{ objectFit: "cover", minHeight: 200 }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {tab === "มาตรฐานและงานวิจัย" && (
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="w-100">
                    <div className="d-flex mb-2">
                      <div className="wpx-100 mb-2">รูปภาพ</div>
                      <div className="d-flex flex-wrap">
                        <input
                          hidden
                          accept="image/*"
                          id="photo_standards"
                          type="file"
                          onChange={async (e) => {
                            loading(true);
                            const file = e.target.files[0];
                            if (!file) return;

                            const reader = new FileReader();
                            reader.onloadend = async () => {
                              const base64 = reader.result;
                              console.log(base64); // ✅ base64
                              // setState(base64) หรือส่งไป API ได้เลย
                              const formdata = new FormData();
                              formdata.append("image", base64.split(",")[1]);

                              const response = await fetch(
                                "https://api.imgbb.com/1/upload?key=" +
                                  process.env.REACT_APP_IMGBB_KEY,
                                {
                                  method: "POST",
                                  body: formdata,
                                }
                              );

                              const result = await response.json();

                              this.setState({
                                photo_standards: result.data.image.url,
                              });
                              loading(false);
                            };
                            reader.readAsDataURL(file);

                            e.target.value = "";
                            e.target.files = null;
                          }}
                        />
                        {photo_standards ? (
                          <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                            <img
                              alt="example"
                              src={photo_standards}
                              className="rounded-3"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <span
                              className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                              style={{ right: -12, top: -12 }}
                              onClick={() => {
                                this.setState({ photo_standards: "" });
                              }}
                            >
                              {"\uf00d"}
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex">
                            <div
                              className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                              onClick={() => {
                                document
                                  .getElementById("photo_standards")
                                  .click();
                              }}
                            >
                              {"\uf03e"}
                            </div>
                            <small className="text-secondary ps-3">
                              <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                              เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                              <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF{" "}
                              <br />
                              <b>ขนาดไฟล์สูงสุด:</b> 5MB
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">หัวข้อ</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อ.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_standards"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_standards"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">รายละเอียด</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียด.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_standards"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_standards"]}
                      />
                    </div>
                    <hr />
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">หัวข้อ 2</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อ 2.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_standards_2"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_standards_2"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">รายละเอียด 2</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียด 2.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_standards_2"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_standards_2"]}
                      />
                    </div>
                    <hr />
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">หัวข้อ 3</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="หัวข้อ 3.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_title_standards_3"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_title_standards_3"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">รายละเอียด 3</div>
                      <textarea
                        className="form-control"
                        placeholder="รายละเอียด 3.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_message_standards_3"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_message_standards_3"]}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div
                      className="overflow-scroll w-100 py-4 bg-light"
                      style={{ maxHeight: "80vh" }}
                    >
                      {/* SECTION 1 */}
                      <div
                        className="w-100 text-white position-relative"
                        style={{
                          minHeight: 350,
                          backgroundImage: `url(${require("../../assets/images/bg-3.jpg")})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      >
                        <div
                          className="text-center p-5 position-relative"
                          style={{
                            minHeight: 350,
                          }}
                        >
                          <div className="w-100 d-flex justify-content-center mt-4">
                            <div
                              className="px-3 py-5 mt-4 rounded"
                              style={{
                                backgroundColor: "rgba(0,0,0,0.3)",
                                maxWidth: 500,
                                minWidth: 300,
                                width: "70%",
                                backdropFilter: "blur(10px)",
                                WebkitBackdropFilter: "blur(10px)", // Safari
                              }}
                            >
                              <h1 className="fw-bold mb-2">
                                {global.i18[tab_ln]?.["มาตรฐานและงานวิจัย"] ||
                                  "มาตรฐานและงานวิจัย"}
                              </h1>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* SECTION 2 */}
                      <div className="w-100">
                        <div className="row bg-secondary-light">
                          <div className="col-12 col-md-6 col-lg-6">
                            <div
                              className="d-none d-md-block position-relative align-content-center"
                              style={{
                                minHeight: 600,
                                backgroundImage: `
                      linear-gradient(to left,
                        rgba(234, 236, 243,1),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0)
                      ),
                      url(${photo_standards || THUMBNAIL})
                    `,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                              }}
                            />
                            <div
                              className="d-block d-md-none position-relative align-content-center"
                              style={{
                                minHeight: 600,
                                backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(234, 236, 243,1),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,1)
                      ),
                      url(${photo_standards || THUMBNAIL})
                    `,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                              }}
                            />
                          </div>

                          <div className="col-12 col-md-6 col-lg-6 text-start px-5">
                            <div className="my-5 py-4">
                              <h2 className="fw-bold mb-4">
                                {this.state[tab_ln + "_title_standards"] ||
                                  th_title_standards}
                              </h2>
                              <div className="text-secondary">
                                {this.state[tab_ln + "_message_standards"] ||
                                  th_message_standards}
                              </div>
                              <div className="mt-3">
                                <button className="btn btn-primary px-3 mb-3 mx-2">
                                  <b className="icon me-2">{"\uf019"}</b>

                                  {global.i18[tab_ln]?.["ดาวน์โหลดงานวิจัย"] ||
                                    "ดาวน์โหลดงานวิจัย"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="py-5">
                          <div className="row mx-0">
                            <div className="col-12 mb-4">
                              <div className="bg-primary-light p-4 rounded-4">
                                <h4 className="fw-bold mb-2 text-primary text-center">
                                  {this.state[tab_ln + "_title_standards_2"] ||
                                    th_title_standards_2}
                                </h4>
                                <div className="text-secondary px-4">
                                  {(
                                    this.state[
                                      tab_ln + "_message_standards_2"
                                    ] || th_message_standards_2
                                  )
                                    .split("\n")
                                    .map((item) => (
                                      <div>{item}</div>
                                    ))}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 mb-4">
                              <div className="p-4 rounded-4">
                                <h4 className="fw-bold mb-2 text-primary">
                                  {this.state[tab_ln + "_title_standards_3"] ||
                                    th_title_standards_3}
                                </h4>
                                <div className="text-secondary px-4">
                                  {(
                                    this.state[
                                      tab_ln + "_message_standards_3"
                                    ] || th_message_standards_3
                                  )
                                    .split("\n")
                                    .map((item) => (
                                      <div>{item}</div>
                                    ))}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 mb-4 d-flex justify-content-center">
                              <button className="btn btn-success px-3 mb-3 mx-2">
                                Bio Conferences
                              </button>

                              <button className="btn btn-primary px-3 mb-3 mx-2">
                                Bureau Veritas Certification
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {tab === "ติดต่อเรา" && (
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="w-100">
                    <h4>ข้อมูลติดต่อที่</h4>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">ชื่อบริษัท</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="ชื่อบริษัท.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_name_contact_1"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_name_contact_1"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">ที่อยู่</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="ที่อยู่.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_address_contact_1"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_address_contact_1"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">เบอร์โทร</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="เบอร์โทร.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_phone_contact_1"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_phone_contact_1"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">แฟกซ์</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="แฟกซ์.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_fax_contact_1"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_fax_contact_1"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">อีเมล</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="อีเมล.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_email_contact_1"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_email_contact_1"]}
                      />
                    </div>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">เว็บไซต์</div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="เว็บไซต์.."
                        onChange={(e) => {
                          this.setState({
                            [tab_ln + "_website_contact_1"]: e.target.value,
                          });
                        }}
                        value={this.state[tab_ln + "_website_contact_1"]}
                      />
                    </div>
                    <hr />
                    <h4>แผนที่</h4>
                    <div className="d-flex mb-3">
                      <div className="wpx-100 mb-2">ฝังโค้ดแผนที่</div>
                      <textarea
                        className="form-control"
                        placeholder="ฝังโค้ดแผนที่.."
                        rows={5}
                        onChange={(e) => {
                          this.setState({
                            map_contact: e.target.value,
                          });
                        }}
                        value={map_contact}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <h3 className="fw-bold mb-3">ตัวอย่าง</h3>
                  <div style={{ zoom: 0.7 }}>
                    <div
                      className="overflow-scroll w-100"
                      style={{ maxHeight: "70vh" }}
                    >
                      {/* SECTION 1 */}
                      <div
                        className="w-100 text-white position-relative"
                        style={{
                          minHeight: 350,
                          backgroundImage: `url(${require("../../assets/images/bg-1.jpg")})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      >
                        <div
                          className="text-center p-5 position-relative"
                          style={{
                            minHeight: 350,
                          }}
                        >
                          <div className="w-100 d-flex justify-content-center mt-4">
                            <div
                              className="px-3 py-5 mt-4 rounded"
                              style={{
                                backgroundColor: "rgba(0,0,0,0.3)",
                                maxWidth: 400,
                                minWidth: 300,
                                width: "70%",
                                backdropFilter: "blur(10px)",
                                WebkitBackdropFilter: "blur(10px)", // Safari
                              }}
                            >
                              <h1 className="fw-bold mb-2">ติดต่อเรา</h1>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* SECTION 2 */}
                      <div className="w-100 position-relative py-5">
                        <div className="container">
                          <div className="row mx-0 pb-5">
                            <div className="col-12 col-lg-6 mb-3">
                              <div className="row">
                                <div className="col-12 col-md-6 col-lg-12 mb-3 px-2">
                                  <h3 className="fw-bold mb-3">
                                    {this.state[tab_ln + "_name_contact_1"] ||
                                      th_name_contact_1}
                                  </h3>
                                  <div className="mb-4">เรายินดีให้คำปรึกษาเกี่ยวกับการจัดการขยะและการเลือกใช้เตาเผาขยะชุมชนที่เหมาะสมกับความต้องการของคุณ ทีมงานผู้เชี่ยวชาญพร้อมดูแล ให้ข้อมูลครบถ้วน ตั้งแต่การออกแบบ ติดตั้ง ไปจนถึงการบริการหลังการขาย</div>
                                  {(this.state[tab_ln + "_address_contact_1"] ||
                                    th_address_contact_1) && (
                                    <div className="d-flex align-items-center mb-3">
                                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                        <h5 className="icon fw-bold text-22">
                                          {"\uf015"}
                                        </h5>
                                      </div>
                                      <div>
                                        <b>
                                          {this.state[
                                            tab_ln + "_name_contact_1"
                                          ] || th_name_contact_1}
                                        </b>
                                        <br />
                                        <span>
                                          {this.state[
                                            tab_ln + "_address_contact_1"
                                          ] || th_address_contact_1}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {(this.state[tab_ln + "_phone_contact_1"] ||
                                    th_phone_contact_1) && (
                                    <div className="d-flex align-items-center mb-3">
                                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                        <h5 className="icon fw-bold text-22">
                                          {"\uf095"}
                                        </h5>
                                      </div>
                                      <div>
                                        <b>
                                          {global.i18[tab_ln]?.["โทรได้ที่"] ||
                                            "โทรได้ที่"}
                                        </b>
                                        <br />
                                        <span>
                                          {this.state[
                                            tab_ln + "_phone_contact_1"
                                          ] || th_phone_contact_1}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {(this.state[tab_ln + "_fax_contact_1"] ||
                                    th_fax_contact_1) && (
                                    <div className="d-flex align-items-center mb-3">
                                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                        <h5 className="icon fw-bold text-22">
                                          {"\uf1ac"}
                                        </h5>
                                      </div>
                                      <div>
                                        <b>
                                          {global.i18[tab_ln]?.["โทรสาร"] ||
                                            "โทรสาร"}
                                        </b>
                                        <br />
                                        <span>
                                          {this.state[
                                            tab_ln + "_fax_contact_1"
                                          ] || th_fax_contact_1}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {(this.state[tab_ln + "_email_contact_1"] ||
                                    th_email_contact_1) && (
                                    <div className="d-flex align-items-center mb-3">
                                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                        <h5 className="icon fw-bold text-22">
                                          {"\uf0e0"}
                                        </h5>
                                      </div>
                                      <div>
                                        <b>
                                          {global.i18[tab_ln]?.["อีเมล"] ||
                                            "อีเมล"}
                                        </b>
                                        <br />
                                        <span>
                                          {this.state[
                                            tab_ln + "_email_contact_1"
                                          ] || th_email_contact_1}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {(this.state[tab_ln + "_website_contact_1"] ||
                                    th_website_contact_1) && (
                                    <div className="d-flex align-items-center mb-3">
                                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                                        <h5 className="icon fw-bold text-22">
                                          {"\uf0ac"}
                                        </h5>
                                      </div>
                                      <div>
                                        <b>
                                          {global.i18[tab_ln]?.["เว็บไซต์"] ||
                                            "เว็บไซต์"}
                                        </b>
                                        <br />
                                        <span>
                                          {this.state[
                                            tab_ln + "_website_contact_1"
                                          ] || th_website_contact_1}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-12 col-lg-6 py-5"
                              id="input-message"
                            >
                              <div className="card card-dashboard rounded-3 bg-secondary-light p-4 shadow-sm border-0">
                                <div className="row">
                                  <div className="col-6">
                                    <div className="mb-2">ชื่อ - นามสกุล</div>
                                    <input
                                      className="form-control mb-3"
                                      type="text"
                                      placeholder="ชื่อ - นามสกุล"
                                    />
                                  </div>
                                  <div className="col-6">
                                    <div className="mb-2">เบอร์โทรศัพท์</div>
                                    <input
                                      className="form-control mb-3"
                                      type="text"
                                      placeholder="เบอร์โทรศัพท์"
                                      maxLength={10}
                                    />
                                  </div>
                                  <div className="col-6">
                                    <div className="mb-2">อีเมล</div>
                                    <input
                                      className="form-control mb-3"
                                      type="email"
                                      placeholder="อีเมล"
                                    />
                                  </div>
                                  <div className="col-6">
                                    <div className="mb-2">บริษัท</div>
                                    <input
                                      className="form-control mb-3"
                                      type="text"
                                      placeholder="บริษัท"
                                    />
                                  </div>
                                  <div className="col-12">
                                    <div className="mb-2">หัวข้อที่สอบถาม</div>
                                    <input
                                      className="form-control mb-3"
                                      type="text"
                                      placeholder="หัวข้อที่สอบถาม"
                                    />
                                  </div>
                                  <div className="col-12">
                                    <div className="mb-2">
                                      ข้อความที่ต้องการติดต่อ
                                    </div>
                                    <textarea
                                      className="form-control mb-3"
                                      rows={8}
                                      placeholder="ข้อความที่ต้องการติดต่อ"
                                    />
                                  </div>
                                  <div className="col-12">
                                    <button className="btn btn-primary px-5 w-100">
                                      ส่งข้อมูล
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <iframe
                              src={map_contact.split('src="')[1].split('"')[0]}
                              width="600"
                              height="450"
                              style={{ border: 0 }}
                              allowfullscreen=""
                              loading="lazy"
                              referrerpolicy="no-referrer-when-downgrade"
                            ></iframe>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="hpx-50" />
          <div
            className="position-fixed px-4 py-3 bg-white w-100"
            style={{ bottom: 0, left: 0 }}
          >
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
